import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import PageBase from '@/components/common/Page'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import SEO from '@/components/head/seo'
import LD from '@/components/head/linking-data'
import LDEntity from '@/utils/linking-data'
import { layouts } from '@/utils/preset'
import Breadcrumb from '@/components/app/Breadcrumb.container'
import PageHead from '@/components/app/PageHead'
import DocumentForm from '@/components/modules/Document/Form'

const DocumentIndexPage = props => (
  <StaticQuery
    query={query}
    render={data => {
      const siteMeta = data.site.siteMetadata
      const title = '資料ダウンロード'
      const description = 'フロントビジョンプランナーの搭載機能やご活用方法、料金プランの紹介などの詳細をPDFの資料にまとめております。ダウンロードは無料ですのでお気軽に資料請求してください。'
      return (
        <Root>
          <SEO location={props.location} title={title} description={description}/>
          <LD json={{
            '@type': 'WebPage',
            '@id': `${siteMeta.siteUrl}/document/#webpage`,
            name: `${title} | ${siteMeta.title}`,
            description: description,
            url: `${siteMeta.siteUrl}/document/`,
            inLanguage: 'ja',
            datePublished: '2019-11-10T10:00:00+09:00',
            dateModified: '2019-11-10T10:00:00+09:00',
            isPartOf: LDEntity.WebSite(siteMeta)
          }}/>
          <Breadcrumb path={props.location.pathname} />
          <Head>
            <PageHead
              title={title}
            />
          </Head>
          <Main>
            <DocumentForm siteMeta={siteMeta}/>
            <Border theme={props.theme} />
          </Main>
        </Root>
      )
    }}
  />
)

const Root = styled.div`
`

const Head = styled.div``

const Main = styled.div``

const Border = styled(layouts.components.FullWidth)`
  height: 1px;
  background-color: ${props => props.theme.line.base};
`

export default PageBase(ThemeConsumer(DocumentIndexPage))

const query = graphql`
  query DocumentIndexPageQuery {
    site {
      siteMetadata {
        siteUrl
        title
        description
        keywords
        image
        company {
          name
          logo
          siteUrl
        }
      }
    }
  }
`
